module.exports = __webpack_public_path__ + "static/assets/cb6aa7cf09c72fa83f6af7595ce55271.svg";